<template>
    <v-layout row wrap justify-center >
      <v-flex xs12 sm10 md8 lg7>
        <v-card>
          <v-container>
            <div>Project #{{jobId}} - {{clientAbbreviation}} {{projectName}}</div>
          </v-container>
          <v-divider></v-divider>
          <v-layout row wrap>
            <v-card-text>
              <v-text-field
                v-model="projectName"
                color="#e7511e"
                label="Project Name"
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-autocomplete
                :items="clients"
                color="#e7511e"
                item-text="name"
                label="Clients"
                v-model="client"
                v-on:change="setClient"
              >
                <template v-slot:item="data">
                  <v-list-item-avatar>
                    <img :src="data.item.icon">
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-html="data.item.name"></v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
              <v-textarea
                filled
                name="input-7-4"
                label="Description"
                hint="Brief description of the project"
                v-model="projectDescription"
                height="20"
              ></v-textarea>
              <v-spacer></v-spacer>
              <v-container>
                <v-radio-group v-model="projectType" class="justify-center">
                  <v-radio active-class="project-types" v-for="pt in projectTypes" :key="pt.id" :label=pt.type :value=pt.id color="#e7511e"></v-radio>
                </v-radio-group>

                <v-row class="ml-10">
                  <v-col cols="12" md="6">
                    <v-switch v-model="showOnWebsite" inset color="#e7511e" label="Add project to ThinkSpatial website"></v-switch>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-icon v-if="showOnWebsite" class="mt-4" color="#e7511e">mdi-check</v-icon>
                  </v-col>
                </v-row>
                <v-row  class="ml-10 justify-center">
                  <v-col cols="3"><v-checkbox color="#e7511e" v-model="onedrive" label="One Drive"></v-checkbox></v-col>
                  <v-col cols="3"><v-checkbox color="#e7511e" v-model="toggl" label="Toggl project"></v-checkbox></v-col>
                  <v-col cols="3"><v-checkbox color="#e7511e" v-model="xero" label="Xero Tracking Category"></v-checkbox></v-col>
                </v-row>
                <v-divider></v-divider>
                <div class="mt-2 project-footer">
                  <v-btn dark color="#e7511e" v-on:click="createProject()">Create Project</v-btn>
                </div>                  
              </v-container>
            </v-card-text>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
</template>

<script>
import AdministrationApi from '@/services/AdministrationApi';
import CommonRules from 'src/common-rules.js';
export default {
  data () {
    return {
      jobId: null,
      client: null,
      clients: [],
      clientAbbreviation: null,
      projectType: 1,
      projectTypes: [],
      projectName: null,
      projectDescription: null,
      showOnWebsite: true,
      onedrive: true,
      toggl: false,
      xero: false,
      rules: CommonRules
    }
  },
  methods: {  
    setClient(){
      let clientData = this.clients.filter(u => u.name === this.client)[0];
      this.clientAbbreviation = clientData.abbreviation.toUpperCase();
    },
    async createProject(){
      let clientInfo = this.clients.filter(u => u.name === this.client)[0];
      if (!clientInfo) {
        this.$swal({
          title: 'Oops!',
          text: 'No client selected.',
          type: 'error'
        });
        return;
      }
      if (!this.projectName) {
        this.$swal({
          title: 'Oops!',
          text: 'No project name given.',
          type: 'error'
        });
        return;
      }
      if (!this.projectDescription) {
        this.$swal({
          title: 'Oops!',
          text: 'No project description given.',
          type: 'error'
        });
        return;
      } 
      let projectParams = {
        jobId: this.jobId,
        projectTitle: this.projectName,
        clientAbbreviation: this.clientAbbreviation,
        clientId: clientInfo.id,
        clientName: clientInfo.name,
        description: this.projectDescription,
        projectTypeId: this.projectType,
        showOnWebsite: this.showOnWebsite,
        onedrive: this.onedrive,
        toggl: this.toggl,
        xero: this.xero,
        proposal: false
      }
      const response = await AdministrationApi.createProject({ projectParams });
      if(!response.data.error) {
        this.$swal({
          title: 'Success!',
          text: response.data.message,
          type: 'success'
        });
        this.client = null;
        this.clientAbbreviation = null;
        this.projectName = null;
        this.projectDescription = null;
        this.projectType = 1;
        this.showOnWebsite = true;
        this.onedrive = true;
        this.toggl = false;
        this.xero = false;
      } else {
        this.$swal({
          title: 'Oops!',
          text: response.data.message,
          type: 'error'
        });
      }
    }
  },
  mounted() {
    AdministrationApi.getProjectTypes().then((pt)=>{
      this.projectTypes = pt.data.projectTypes;
    })
    .catch(error => {
      if (error.response) {
        if (error.response.status === 403) {
          this.rules.resourceForbidden(error, this);
        } else {
          console.log(error.response.data);
        }
      }
    });
    AdministrationApi.getClients().then((clients)=>{
      this.clients = clients.data.clients;
    })
    .catch(error => {
      if (error.response) {
        if (error.response.status === 403) {
          this.rules.resourceForbidden(error, this);
        } else {
          console.log(error.response.data);
        }
      }
    });
    AdministrationApi.nextJobId({ isProposal: false }).then((jobid)=>{
      this.jobId = jobid.data.jobid;
    })
    .catch(error => {
      if (error.response) {
        if (error.response.status === 403) {
          this.rules.resourceForbidden(error, this);
        } else {
          console.log(error.response.data);
        }
      }
    });
  },
}
</script>

<style scoped>
  .carbine-new-project-container{
    width: 96%;
    margin: 0 auto;
    padding: 20px;
  }
  .project-types {
    font-size: 10px;
  }
  .project-footer{
    margin-bottom:100px;
  }
</style>